import { render, staticRenderFns } from "./myTask.vue?vue&type=template&id=54667592&scoped=true&"
import script from "./myTask.vue?vue&type=script&lang=js&"
export * from "./myTask.vue?vue&type=script&lang=js&"
import style0 from "./myTask.vue?vue&type=style&index=0&id=54667592&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54667592",
  null
  
)

export default component.exports